const deliverMethodForms = document.querySelectorAll('.delivery-methods-form')
const priceBeforeVat = document.querySelector('.cartlist__pricebeforevat p')
const priceBeforeVatMobile = document.querySelector('.cartlist__pricebeforevat-mobile')
const deliveryCharge = document.querySelector('.cartlist__delivery p')
const deliveryChargeMobile = document.querySelector('.cartlist__delivery-mobile')
const price = document.querySelector('.cartlist__totalprice p ')
const priceMobile = document.querySelectorAll('.cartlist__totalprice-mobile')
const deliveryMethodString = document.querySelector('.cartlist__deliverymethod')

const CheckoutForm = {
  init(target) {
    const form = target
    const submitBtn = form.querySelector("button[type='submit']")

    this.disableSubmitButton(true, submitBtn)

    deliverMethodForms.forEach((dform: HTMLFormElement) => {
      const deliveryInput: HTMLFormElement = dform.querySelector('input[name="ShippingProvider"]')

      if (deliveryInput.checked) {
        this.deliverySubmit(dform, submitBtn, form)
      }

      deliveryInput.addEventListener('change', (e: InputEvent) => {
        e.preventDefault()
        this.deliverySubmit(dform, submitBtn, form)
      })
    })

    form.addEventListener('submit', () => {
      this.submitButtonLoading(true, submitBtn)
    })
  },

  inputSelectChange(e: InputEvent, submitBtn) {
    if (e.currentTarget instanceof HTMLInputElement && e.currentTarget.checked) {
      this.disableSubmitButton(false, submitBtn)
    }
  },

  disableSubmitButton(value: boolean, submitBtn) {
    if (value) {
      submitBtn.setAttribute('disabled', 'disabled')
      submitBtn.classList.add('button--disabled')
    } else {
      submitBtn.removeAttribute('disabled')
      submitBtn.classList.remove('button--disabled')
    }
  },

  submitButtonLoading(value: boolean, submitBtn) {
    if (value) {
      submitBtn.setAttribute('disabled', 'disabled')
      submitBtn.classList.add('button--loading')
    } else {
      submitBtn.removeAttribute('disabled')
      submitBtn.classList.remove('button--loading')
    }
  },

  async deliverySubmit(dform: HTMLFormElement, submitBtn, form) {
    const data = new FormData(dform)
    const action = dform.getAttribute('action')
    const formMethod = dform.getAttribute('method')
    const shippingProvider: HTMLInputElement = dform.querySelector("input[name='ShippingProvider']")

    data.append('ShippingProvider', shippingProvider.value)

    fetch(action, {
      method: formMethod,
      body: data,
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.success) {
          // form.reset();
          this.disableSubmitButton(false, submitBtn)

          // deliveryCharge.innerHTML = response.orderInfo.ChargedAmount.CurrencyString;

          const shippingCost = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'ISK',
            currencyDisplay: 'narrowSymbol',
          }).format(response.orderInfo.ShippingProvider.Price.Value)
          deliveryCharge.innerHTML = shippingCost
          deliveryChargeMobile.innerHTML = shippingCost

          deliveryMethodString.innerHTML = response.orderInfo.ShippingProvider.Title

          price.innerHTML = response.orderInfo.ChargedAmount.CurrencyString
          priceMobile.forEach((item) => {
            item.innerHTML = response.orderInfo.ChargedAmount.CurrencyString
          })

          let total = 0
          response.orderInfo.OrderLines.forEach((line) => {
            total += line.Amount.WithoutVat.Value
          })

          priceBeforeVat.innerHTML = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'ISK',
            currencyDisplay: 'narrowSymbol',
          }).format(total)
          priceBeforeVatMobile.innerHTML = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'ISK',
            currencyDisplay: 'narrowSymbol',
          }).format(total)
        } else {
          console.log('error')
        }
      })
      .catch((ex) => {
        console.log(form, `Server error: ${ex}`, 'error')
      })
  },
}

export default CheckoutForm
